// heic-to 1.6.6's public heicTo() chooses data[0], not the primary image.
// Its shipped CSP-safe libheif build exposes is_primary() and explicit disposal.
// Keep this exact-version internal-path coupling covered by real browser fixtures.
import buildLibheif from '../node_modules/heic-to/src/lib/libheif-without-unsafe-eval.js'

export async function primaryHeicToJpeg(file) {
  // A fresh instance per image lets its large decoder heap become collectible.
  const libheif = await buildLibheif()
  let decoder
  let images
  let canvas
  try {
    decoder = new libheif.HeifDecoder()
    images = decoder.decode(await file.arrayBuffer())
    const primary = images.find((image) => image.is_primary())
    if (!primary) throw new Error('HEIF primary still not found')
    const width = primary.get_width()
    const height = primary.get_height()
    const pixels = new ImageData(width, height)
    const decoded = await libheif.heif_js_decode_image2(
      primary.handle,
      libheif.heif_colorspace.heif_colorspace_RGB,
      libheif.heif_chroma.heif_chroma_interleaved_RGBA,
    )
    try {
      if (!decoded || decoded.code) throw new Error('HEIF decoding failed')
      const rgba = decoded.channels.find((channel) => channel.id === libheif.heif_channel.heif_channel_interleaved)
      if (!rgba || rgba.width !== width || rgba.height !== height) throw new Error('Invalid HEIF pixel dimensions')
      if (rgba.stride === width * 4) pixels.data.set(rgba.data)
      else for (let y = 0; y < height; y++) {
        pixels.data.set(rgba.data.subarray(y * rgba.stride, y * rgba.stride + width * 4), y * width * 4)
      }
    } finally {
      if (decoded?.image) libheif.heif_image_release(decoded.image)
    }
    canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const context = canvas.getContext('2d')
    // JPEG has no alpha. Composite transparent HEIF pixels against white.
    context.putImageData(pixels, 0, 0)
    context.globalCompositeOperation = 'destination-over'
    context.fillStyle = '#fff'
    context.fillRect(0, 0, width, height)
    return await new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob && blob.type === 'image/jpeg') resolve(blob)
        else reject(new Error('HEIF JPEG encoding failed'))
      }, 'image/jpeg', 0.95)
    })
  } finally {
    if (canvas) canvas.width = canvas.height = 1
    if (images) for (const image of images) image.free()
    if (decoder?.decoder) libheif.heif_context_free(decoder.decoder)
  }
}
